module.exports = __webpack_public_path__ + "img/puyanggongyequAppImage.81359497.png";